import Vue from 'vue'

export const SET_ERROR = (state, error) => {
  Vue.set(state, 'errors', [...state.errors, error])
}

export const RESET_ERRORS = (state) => {
  Vue.set(state, 'errors', [])
}

export const SET_LOADING = (state, flag) => {
  Vue.set(state, 'loading', flag)
}

export const SET_TOKEN = (state, token) => {
  Vue.set(state, 'token', token)
}

export const SET_PROFILE = (state, profile) => {
  Vue.set(state, 'profile', profile)
}

export const SET_LICENSE = (state, license) => {
  Vue.set(state, 'license', license)
}

export const SET_PRODUCT_CONFIG = (state, {product, config}) => {
  Vue.set(state.products, product, config)
}

export const UPDATE_CONFIG_VALUES = (state, {product, selected_fields}) => {
  // console.log({product, selected_fields})
  // console.log(state.products[product])
  Vue.set(state.products[product], 'selected_fields', selected_fields)
}

export const SET_REQUEST_TRUE = (state) => {
  Vue.set(state, 'request2buy', true)
}

export const LOGOUT = (state) => {
  Vue.set(state, 'products', {})
  Vue.set(state, 'license', null)
  Vue.set(state, 'profile', null)
  Vue.set(state, 'token', null)
}
